import { VoiceSamplePanel } from '@/components/humint/voice/VoiceSamplePanel'
import type { VoiceSampleContext } from '@/components/humint/voice/voice-types'
import { useReadout } from '../recording/readout-store'
import type { VoiceSampleFlow } from './useVoiceSampleFlow'

export interface VoiceSampleFlowPanelProps {
  flow: VoiceSampleFlow
  /** What the sample is for, and whose voice it is (none before the subject exists). */
  context: VoiceSampleContext
}

/**
 * The voice-sample panel on a flow (`useVoiceSampleFlow`). The one component that follows the
 * counted speech and the level: they move ten times a second while it records, and nothing
 * around the panel has to render for that.
 */
export function VoiceSampleFlowPanel({ flow, context }: VoiceSampleFlowPanelProps) {
  const readout = useReadout(flow.readout)
  const { view, player, actions } = flow
  return (
    <VoiceSamplePanel
      view={view}
      context={context}
      live={{ readout, player }}
      actions={{
        ...actions,
        ...(view.phase === 'instructions' && !view.starting
          ? { onImportFile: flow.importFile }
          : {}),
      }}
    />
  )
}
